import { useUsersStore } from '@/stores/users'

// Callbacks para eventos de telefonia
const telephonyCallbacks = {
    onCallRing: null,
    onCallAnswer: null,
    onCallEnd: null,
}

/**
 * Registra callbacks para eventos de telefonia
 * @param {Object} callbacks - { onCallRing, onCallAnswer, onCallEnd }
 */
export function registerTelephonyCallbacks(callbacks) {
    Object.assign(telephonyCallbacks, callbacks)
}

/**
 * Manipula eventos de telefonia recebidos via WebSocket
 * @param {Object} data - Dados do evento de telefonia
 */
export function handleTelephonyEvent(data) {
    const usersStore = useUsersStore()
    const currentUser = usersStore.me
    
    // Verifica se o usuário tem telefonia configurada
    if (!currentUser?.telephony) {
        console.log('[Telephony Event] User has no telephony configured, ignoring event')
        return
    }
    
    // Pega o ramal do usuário logado
    const userExtension = currentUser.telephony.more?.ramal
    if (!userExtension) {
        console.warn('[Telephony Event] User has no extension configured')
        return
    }
    
    // Pega o ramal do evento
    const eventExtension = data.extension
    
    console.log('[Telephony Event] Extension check:', {
        userExtension,
        eventExtension,
        match: userExtension === eventExtension
    })
    
    // Ignora eventos de outros ramais
    if (userExtension !== eventExtension) {
        console.log('[Telephony Event] Event is for different extension, ignoring')
        return
    }
    
    console.log('[Telephony Event] Processing event:', data.event_type, data)
    
    // Mapeia event_type para status do banco
    // Status: 0=AVAILABLE, 1=BUSY, 2=AWAY, 3=OFFLINE
    
    switch (data.event_type) {
        case 'FREE':
            // Ramal livre (não está em fila)
            updateUserTelephonyStatus(3) // OFFLINE
            break
            
        case 'QUEUE_IN':
            // Entrou na fila
            if (data.queue_data?.pause_status_code === 1) {
                updateUserTelephonyStatus(2) // AWAY (pausado)
            } else {
                updateUserTelephonyStatus(0) // AVAILABLE
            }
            break
            
        case 'QUEUE_OUT':
            // Saiu da fila
            updateUserTelephonyStatus(3) // OFFLINE
            break
            
        case 'PAUSE_IN':
            // Entrou em pausa
            updateUserTelephonyStatus(2) // AWAY
            break
            
        case 'PAUSE_OUT':
            // Saiu da pausa
            updateUserTelephonyStatus(0) // AVAILABLE
            break
            
        case 'CALL_RING':
            // Chamada tocando - atualiza para BUSY para mostrar que está recebendo chamada
            updateUserTelephonyStatus(1) // BUSY
            telephonyCallbacks.onCallRing?.()
            break
            
        case 'CALL_ANSWER':
            // Atendeu a chamada - mantém BUSY
            updateUserTelephonyStatus(1) // BUSY
            telephonyCallbacks.onCallAnswer?.()
            break
            
        case 'CALL_MISSED':
            // Chamada perdida (não atendeu)
            // Verifica se ainda está na fila
            if (data.queue_data?.list?.length > 0) {
                if (data.queue_data?.pause_status_code === 1) {
                    updateUserTelephonyStatus(2) // AWAY
                } else {
                    updateUserTelephonyStatus(0) // AVAILABLE
                }
            } else {
                updateUserTelephonyStatus(3) // OFFLINE
            }
            telephonyCallbacks.onCallEnd?.()
            break
            
        case 'CALL_END':
            // Chamada finalizada
            // Verifica se ainda está na fila
            if (data.queue_data?.list?.length > 0) {
                if (data.queue_data?.pause_status_code === 1) {
                    updateUserTelephonyStatus(2) // AWAY
                } else {
                    updateUserTelephonyStatus(0) // AVAILABLE
                }
            } else {
                updateUserTelephonyStatus(3) // OFFLINE
            }
            telephonyCallbacks.onCallEnd?.()
            break
            
        default:
            console.warn('[Telephony Event] Unknown event type:', data.event_type)
    }
}

/**
 * Atualiza o status de telefonia do usuário localmente
 * @param {number} status - Novo status (0=AVAILABLE, 1=BUSY, 2=AWAY, 3=OFFLINE)
 */
function updateUserTelephonyStatus(status) {
    const usersStore = useUsersStore()
    
    if (usersStore.me?.telephony) {
        // Força a reatividade usando Vue
        const telephony = usersStore.me.telephony
        telephony.status = status
        console.log('[Telephony] Status updated to:', status, 'Current user telephony:', usersStore.me.telephony)
    } else {
        console.warn('[Telephony] Could not update status - no telephony config found')
    }
}
